// @flow
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { defineMessages, FormattedMessage, intlShape } from 'react-intl';
import moment from 'moment';

import style from './TravelerInfo.scss';
import icons from '../../../../../assets/styles/icons.scss';
import boxStyle from '../../../../../assets/styles/box.scss';
import avatarStyle from '../../../../../assets/styles/avatar.scss';
import defaultPic from '../../../../../assets/img/profileplaceholder.jpg';

import type { Flight, Order, UserMini } from '../../../../../entities';

type Props = {
  +order: Order;
};

const messages = defineMessages({
  arrivalOrReception: {
    id: 'order.travelerInfo.arrival',
  },
  flight: {
    id: 'order.travelerInfo.flight',
  },
  delivery: {
    id: 'order.travelerInfo.delivery',
  },
  courier: {
    id: 'order.travelerInfo.courier',
  },
  beforeDate: {
    id: 'order.travelerInfo.beforeDate',
  },
});

export default class TravelerInfo extends Component<Props> {

  /*getTravelerInfoText(): string {
    const { order } = this.props;
    const flight: ?Flight = order.flight;
    switch (order.state) {
      case 'PURCHASED':
      case 'RECEIVED':
        return `${this.context.intl.formatMessage(messages.arrivalOrReception)}:
        ${flight ? moment(flight.flightDate).format('MMM DD, YYYY') : ''}`;
      case 'ARRIVED':
      case 'IN_QEMPO':
        return this.context.intl.formatMessage(messages.flight);
      case 'IN_QEMPO_CONFIRMED':
        return this.context.intl.formatMessage(messages.delivery);
      case 'SHIPPING':
      case 'DELIVERED':
        return this.context.intl.formatMessage(messages.courier);
      default:
        return '';
    }
  }*/

  formatFlightLocation = (flight: Flight): [string, string] => {
    let d, a;
    if (flight.departureAdmin2) {
      d = `${flight.departureAdmin2.name}, ${flight.departureCountry.code3}`;
    } else if (flight.departureAdmin1) {
      d = `${flight.departureAdmin1.name}, ${flight.departureCountry.code3}`;
    } else {
      d = flight.departureCountry.code3;
    }
    if (flight.arrivalAdmin2) {
      a = `${flight.arrivalAdmin2.name}, ${flight.arrivalCountry.code3}`;
    } else if (flight.arrivalAdmin1) {
      a = `${flight.arrivalAdmin1.name}, ${flight.arrivalCountry.code3}`;
    } else {
      a = flight.arrivalCountry.code3;
    }
    return [d, a];
  };

  render() {
    const { order } = this.props;
    const menuOptions = [
      {
        labelIntl: 'order.travelerInfo.report',
        icon: icons.symbolWarning,
        color: 'red',
        handler: () => {
          console.log('click');
        },
      },
    ];
    const traveler: ?UserMini = order.traveler;
    const flight: ?Flight = order.flight;
    // const travelerInfoText = this.getTravelerInfoText();
    const [departureLabel, arrivalLabel] = this.formatFlightLocation(flight);

    return traveler && flight ? (
      <section className={classNames(boxStyle.box, style.box)}>
        {/*<DotsMenu orientation="left"
                  buttonStyle={style.dotsButton}
                  menuOptions={menuOptions}/>*/}
        <article className={style.topContent}>
          <img src={traveler.image || defaultPic}
               className={classNames(avatarStyle.avatar, avatarStyle.large)}/>
          <section className={style.infoWrap}>
            <p className={style.name}>{traveler.firstName}</p>
            <p className={style.flight}>{`${departureLabel} - ${arrivalLabel}`}</p>
          </section>
        </article>
        {!['TRAVELER_CANCELED', 'BUYER_CANCELED', 'QEMPO_CANCELED', 'QEMPO_CANCELED_FOR_FRAUD',
          'DELIVERY_CONFIRMED', 'RETURNED', 'ABANDONED', 'EXPIRED']
          .includes(order.state) &&
        <article className={style.bottomContent}>
          {/*<p><i className={icons.iconCalendarLight}/>{travelerInfoText}</p>*/}
          <FormattedMessage id="order.travelerInfo.beforeDate">{
            txt => <p>
              <i className={icons.iconDeliverBoxMedium}/>{txt}: {moment(order.beforeDate).format('DD MMM YYYY')}
            </p>
          }</FormattedMessage>
        </article>}
      </section>
    ) : null;
  }
}

TravelerInfo.propTypes = {
  order: PropTypes.object.isRequired,
};

TravelerInfo.contextTypes = {
  intl: intlShape,
};



// WEBPACK FOOTER //
// ./src/modules/order/Purchase/components/TravelerInfo/TravelerInfo.jsx